import _ from 'lodash'
import serviceConnect from './axios-connect'

const X_CSRF = 'x-csrftoken'

// simple wrapper around axios connect for simple fetch requests
// you will need to handle the errors from catch
function getService(
  url,
  params = {},
  paramsSerializer = null,
  timeout = 20000
) {
  return serviceConnect
    .get(url, { params, paramsSerializer, timeout })
    .then(({ data }) => data)
}

function postService(url, params = {}) {
  return serviceConnect.post(url, params).then(({ data }) => data)
}

function patchService(url, body, params = {}, config = {}) {
  return serviceConnect
    .patch(url, body, { params, ...config })
    .then(({ data }) => data)
}

function csrfService() {
  return serviceConnect.options('/csrf/').then(data => {
    return _.get(data, ['headers', X_CSRF])
  })
}

function buildMultiPartPayload({ params, files, fileKey }) {
  const formData = new FormData()
  if (Array.isArray(files)) {
    files.forEach(file => {
      formData.append(fileKey, file)
    })
  } else {
    formData.append(fileKey, files)
  }

  Object.keys(params).forEach(key => {
    let value = params[key]
    if (typeof value !== 'string') {
      value = JSON.stringify(value)
    }
    formData.append(key, value)
  })
  return formData
}

export default {
  getService,
  postService,
  patchService,
  csrfService,
  X_CSRF,
  buildMultiPartPayload
}
